import { render } from "./SiteStatsGrowth.vue?vue&type=template&id=28c994f2&scoped=true"
import script from "./SiteStatsGrowth.vue?vue&type=script&lang=js"
export * from "./SiteStatsGrowth.vue?vue&type=script&lang=js"

import "./SiteStatsGrowth.vue?vue&type=style&index=0&id=28c994f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c994f2"]])

export default __exports__